const styles = theme => ({
  paddingBottom: {
    paddingBottom: '100px',
  },
  mobileTitleHead: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '20px',
    borderBottom: '3px solid #EBEEF3',
    '& h2': {
      fontSize: '16px',
      fontWeight: 500,
    },
  },
  switchContainer: {
    justifyContent: 'center',
    display: 'flex',
    marginBottom: '16px',
  },
  titleHead: {
    color: theme.palette.primary.adgmBlack,
    '& h1': {
      fontWeight: 500,
      fontSize: '1.5rem',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
        paddingLeft: '15px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: '25px',
    },
  },
  paginationHolder: {
    marginBottom: '80px',
    display: 'flex',
    justifyContent: 'flex-start',
    // [theme.breakpoints.down('sm')]: {
    //   padding: '0 15px',
    // },
  },
  pagination: {
    justifyContent: 'center',
    marginBottom: '20px',
  },
  footer: {
    position: 'fixed',
    bottom: '0',
    left: '0',
    right: '0',
    background: '#fff',
    padding: '16px',
    borderTop: `1px solid ${theme.palette.secondary.disableLightGray}`,
    zIndex: '10',
    '& $container': {
      [theme.breakpoints.down('sm')]: {
        padding: '0',
      },
    },
    '& button': {
      minWidth: '180px',
      minHeight: 'auto',
      height: 'auto',
      padding: '16px',
      fontWeight: '600',
      fontSize: '16px',
      lineHeight: '150%',
      borderRadius: '8px',
      color: '#fff',
      textTransform: 'capitalize',
      background: theme.palette.primary.main,
      '&:hover': {
        background: theme.palette.primary.main,
        boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.3)',
      },
      '&:disabled': {
        background: theme.palette.primary.darkGrey,
        border: '0',
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: 'auto',
        width: '100%',
      },
    },

    '& $backButton': {
      background: theme.palette.primary.white,
      color: theme.palette.primary.adgmBlack,
      border: `1px solid ${theme.palette.primary.adgmBlack}`,
      textTransform: 'lowercase',
      '& ::first-letter': {
        textTransform: 'uppercase',
      },
    },
    '& $backButton:hover': {
      background: theme.palette.primary.white,
    },
  },
  pmaFooter: {
    position: 'fixed',
    bottom: '0',
    left: '0',
    right: '0',
    background: '#fff',
    padding: '16px',
    borderTop: '3px solid #EBEEF3',
    zIndex: '1',
    '& $container': {
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: '1184px',
      [theme.breakpoints.down('sm')]: {
        padding: '0',
      },
    },
    '& button': {
      minWidth: '151px',
      padding: '15px',
      height: '60px',
      fontWeight: '600',
      fontSize: '16px',
      borderRadius: '10px',
      color: '#fff',
      textTransform: 'capitalize',
      background: theme.palette.primary.main,
      '&:hover': {
        background: theme.palette.primary.main,
        boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.3)',
      },
      '&:disabled': {
        background: theme.palette.primary.darkGrey,
      },
    },
  },
  container: {},
  backButton: {},

  // No Data
  transactionsNotification: {
    textAlign: 'center',
    padding: '20px',
    '& $tcTextHolder': {
      maxWidth: '300px',
      margin: '0 auto',
      '& $title': {
        marginBottom: '8px',
        fontSize: '14px',
      },
      '& p': {
        color: '#8C9099',
        fontSize: '12px',
      },
    },
  },
  tcTextHolder: {},
  title: {},
  infoMessageTooltip: {
    background: '#EBF7FF',
    color: '#342D3D',
    borderRadius: '10px',
    border: '1px solid #0496FF',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minHeight: '44px',
    padding: '12px 22px',
    marginBottom: '25px',
    '& img': {
      marginRight: '8px',
    },
    '& strong': {
      fontWeight: '600',
      color: '#1270B4',
      marginLeft: '3px',
      '& a': {
        textDecoration: 'none',
        color: theme.palette.primary.main,
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
  },

  '@media (max-width: 959px)': {
    title: {
      fontSize: '16px',
    },
    switchContainer: {
      marginBottom: '20px',
    },
  },
  '@media (min-width: 960px)': {
    title: {
      fontWeight: '600',
      marginBottom: '7px',
    },
  },
  '@media (min-width: 600px)': {
    transactionsNotification: {
      '& $tcTextHolder': {
        '& $title': {
          fontSize: '16px',
        },
        '& p': {
          fontSize: '14px',
        },
      },
    },
  },
  '@media (max-width: 599.95px)': {
    footer: {
      bottom: '68px',
    },
    pmaFooter: {
      bottom: '68px',
    },
  },
  actionsWrapper: {
    display: 'flex',
    width: '100%',
    gap: '24px',
    [theme.breakpoints.down('sm')]: {
      gap: '0px',
    },
  },
});

export default styles;
